export const formatCurrency = (n) => {
  const v = parseFloat(n) || 0;
  return '₹ ' + v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatDate = (d) => {
  if (!d) return '-';
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const today = () => new Date().toISOString().split('T')[0];

export const monthStart = () => {
  const d = new Date(); d.setDate(1);
  return d.toISOString().split('T')[0];
};

export const daysBetween = (d1, d2) => {
  const ms = new Date(d2) - new Date(d1);
  return Math.round(ms / (1000 * 60 * 60 * 24));
};

// -----------------------------------------------------------------------------
// Approval-workflow helpers (v1.5)
// -----------------------------------------------------------------------------
export const getCurrentUser = () => {
  try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
};

export const isAdminUser = () => {
  const u = getCurrentUser();
  return !!u && u.role === 'admin';
};

// Can current user modify (edit/delete) this record?
// admin: always. others: only their own pending records.
export const canModifyRecord = (record) => {
  if (!record) return false;
  const u = getCurrentUser();
  if (!u) return false;
  if (u.role === 'admin') return true;
  if (record.approval_status === 'approved') return false;
  return parseInt(record.created_by) === parseInt(u.id);
};

export const approvalBadge = (status) => {
  if (status === 'pending') return { cls: 'badge badge-orange', label: 'Pending' };
  return { cls: 'badge badge-green', label: 'Approved' };
};
